import { useContext } from "react";
import { FoodContext } from "../contexts/foodConfigContext";



export function useFoodConfig() {
    const value = useContext(FoodContext);
    return value;
}